<template>
  <van-popup position="bottom" v-model="visible" :close-on-click-overlay="false">
    <van-datetime-picker v-if="isDate" :max-date="maxDate" v-model="defaultDate" type="date" :min-date="minDate" @cancel="close" @confirm="dateConfirm" />
    <van-picker ref="vanPicker" v-else show-toolbar :columns="columns" @cancel="close" @confirm="confirm" />
  </van-popup>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'BasePicker',

  props: {
    type: String,
    visible: {
      type: Boolean,
      default: false
    },
    value: [String, Number],
    columns: Array,
    minDate: Date,
    maxDate: Date,
    initIndex: Number
  },

  data () {
    return {
      defaultDate: new Date(),
      hasInit: false
    }
  },

  computed: {
    isDate () {
      return this.type === 'date'
    }
  },

  watch: {
    async visible (newVal) {
      await this.$nextTick()
      console.log(newVal)
      if (!this.hasInit && this.$refs.vanPicker && this.initIndex) {
        this.$refs.vanPicker.setIndexes([this.initIndex])
        this.hasInit = true
      }
    },
    value (val) {
      if (val && this.isDate) this.defaultDate = dayjs(val).toDate()
    },
    columns () {
      if (this.$refs.vanPicker) this.$refs.vanPicker.setIndexes([0])
    }
  },

  methods: {
    close () {
      this.$emit('update:visible', false)
    },
    dateConfirm (val) {
      this.$emit('update:value', dayjs(val).format('YYYY-MM-DD'))
      this.close()
    },
    confirm (value, index) {
      this.$emit('update:value', { value, index })
      this.close()
    }
  }
}
</script>
